<!--
  File name: PBNEFList.vue
  Program Description:
    - This component renders the list of drafted PBNEF
    - Each item is clickable to view the a specific PBNEF draft

  Includes:
    - PBNEFBreadCrumbs for header actions
    - PBNEFList with Drafted type parameter
-->
<template>
  <v-container>
    <PBNEFBreadCrumbs />
    <v-row
      align-self="start"
      justify="center"
    >
      <v-col class="mb-0 pb-0">
        <v-card
          tile
          elevation="0"
          outlined
        >
          <v-card-title class="pt-2 pb-2">
            <v-btn
              id="back-btn"
              color="grey darken-1"
              text
              :loading="$meta.loading"
              @click="$router.push({
                name: 'PBNEFLanding'
              })"
            >
              <v-icon>mdi-arrow-left-thin</v-icon> Back to PBNEF List
            </v-btn>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <v-row
      align-self="start"
      justify="center"
    >
      <v-col class="mb-0 pb-0">
        <PBNEFList
          v-if="dbnNumber"
          type="Drafted"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import pbnefMixin from '@/mixins/pbnefMixin'
import PBNEFBreadCrumbs from './PBNEFBreadCrumbs.vue'
import PBNEFList from './PBNEFList.vue'
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'PBNEFDrafts',
  components: {
    PBNEFBreadCrumbs,
    PBNEFList
  },
  mixins: [
    pbnefMixin
  ],
  ...mapFields('pbnef', {
    isSubmitted: 'isSubmitted'
  }),
  mounted () {
    this.$store.dispatch('pbnef/set', {
      isSubmitted: false
    })
  }
}
</script>

<style scoped>
.transparent-bg {
  background-color: rgba(0,0,0,0);
}

.v-btn {
  text-transform: none;
}
</style>
